import "antd/dist/antd.css";
import React, { Suspense, lazy } from "react";
import { Switch, Route, HashRouter } from "react-router-dom"
import '../css/App.css';

const RunSearchPage = lazy(() => import("./RunSearchPage"));
const RunViewPage = lazy(() => import("./RunViewPage"));

const App = () => {
  return (
    <div className="App">
      <HashRouter>
        <Suspense fallback={<div></div>}>
          <Switch>
            <Route path="/run/:runId" component={RunViewPage} />
            <Route path="/" component={RunSearchPage} />
          </Switch>
        </Suspense>
      </HashRouter>
    </div>
  );
}

export default App;
